import $ from 'jquery'
import PDFPreviewLightbox from './overtimeReport/PDFPreviewLightbox'
import PDFGenerator from '../pdf/overtimeReport/PDFGenerator'
import {ReportType} from './constants'
import OvertimeReportEditConfigController from './edit_config_controller/overtime/OvertimeReportEditConfigController'
import ReportPrintableHeadersBuilder from './ReportPrintableHeadersBuilder'
import messageResource from '../messageResource'
import {ReportConfigConstants} from 'constants'
import makeRpcCall from '../util/jquery_rpc'
import {ColumnsConfig} from './overtimeReport/ColumnsConfig'
import {arrayToMap} from '../atUtils'
import ReportMediator from './ReportMediator'
import OvertimeReportStore from './overtimeReport/OvertimeReportStore'
import {downloadJsonAsCSV} from '../csv/utils'

export default function OvertimeReportMediator ()
{
    this.constructor = OvertimeReportMediator;
}

OvertimeReportMediator.prototype = _.create(ReportMediator.prototype)

OvertimeReportMediator.prototype.init = function ( config )
{
    ReportMediator.prototype.init.call(this, config);

    this._initStore(config);
    this._initControllers();

    this.eventNamespace = "OvertimeReport";
    this.store = OvertimeReportStore;

    this.productSettingsValidator = new ATProductSettingsValidator();
    this.reportRightsValidator = new ATReportRightsValidator();

    new BaseReport.PDFPreviewLightboxTemplateView($("body"), "OvertimePdfPreviewLightbox", "lightboxWithWhiteContent pdfPreviewLightbox noprint").init();

    this.pdfPreviewLightbox = new PDFPreviewLightbox().init({
            popupId: "OvertimePdfPreviewLightbox",
            closeBtnId: "closeViewTTPdfPreviewLightboxButton",
            eventNamespace: this.eventNamespace,
            productSettingsValidator: this.productSettingsValidator,
            reportRightsValidator: this.reportRightsValidator,
        })

    this.initPDFEvents();

    this.initCSVEvents();
    
    ATReportsStore.setVisibleUsers(config.users);
    ATReportsStore.setUserGroups(config.userGroups);
    ATReportsStore.setTimeZoneGroups(config.timeZoneGroups);

    return this;
};


OvertimeReportMediator.prototype._initStore = function(config)
{
    //
};

OvertimeReportMediator.prototype._initControllers = function()
{
    const self = this;
    this.ExportSelector = new ExportPanel($("body"), "OvertimeReport.showPDFPreview", "OvertimeReport.createCSV").init();

    this.$exportButton = $(".export");
    this.$exportButton.click(function() { if (!self.$exportButton.hasClass('disabled'))  self.ExportSelector.showAt($(this)); });
};

OvertimeReportMediator.prototype.generateCSV = function()
{
    const generator = new OvertimeCSVJsonConverter().init(this.store, ATReportsStore);
    const params = this.store.getReportParams();

    const jsonTitle = generator.convertTitle(params);
    const jsonTable = generator.convertLinearTable(params, this.store.getReportData());
    const jsonTotal = generator.convertTotal(params, this.store.getReportData());
    
    downloadJsonAsCSV([jsonTitle, jsonTable, jsonTotal], generator.generateCSVName(params));
};

OvertimeReportMediator.prototype.getEventName = function(event)
{
    return this.eventNamespace + "." + event;
};

OvertimeReportMediator.prototype.cancelAllPDFExportingProcesses = function()
{
    if (this.pdfGenerator)
        this.pdfGenerator.interruptGeneration();
    this.pdfPreviewLightbox.cancelAllExportingProcesses();
};

OvertimeReportMediator.prototype.generatePDF = function()
{
    this.pdfGenerator = new PDFGenerator().init(
        this.store,
        ATReportsStore,
        this.productSettingsValidator,
        this.reportRightsValidator,
    )

    $(document).trigger(this.getEventName("pdfGenerator.start"));
    const self = this;
    this.pdfGenerator.generatePDF(function(config, onDataProvided) {}).then(
            function(pdf)
            {
                self.store.setGeneratedPDF(pdf.encodedPDF);
                self.store.setPDFFileName(pdf.fileName);
            },
            function(error)
            {
                if (error.message !== "abort")
                {
                    console.error(error);
                }
            });
};

OvertimeReportMediator.prototype.getReportType = function()
{
    return ReportType.OVERTIME;
};

OvertimeReportMediator.prototype.initEditConfigController = function( config )
{
    const self = this;
    return new OvertimeReportEditConfigController().init(
            {
                reportAuthorizationInfo: config.reportAuthorizationInfo,
                reportParameters:config.reportParameters,
                users: config.users,
                manageableUsersIds: config.manageableUserIds,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                changeCallback: function(){ self.changeParametersCallback(); }
            } );
};

OvertimeReportMediator.prototype.initPrintableHeadersBuilder = function( config ) {
    return new ReportPrintableHeadersBuilder().init(
            {
                users: config.users,
                reportParameters: config.reportParameters,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
            }
    );
};

OvertimeReportMediator.prototype._populateHeadersArray = function( headersArray ) {
    this.printableHeadersBuilder.addStaffSelectionParamsToArray( this.reportParameters.userSelection, headersArray ); //staff
};

OvertimeReportMediator.prototype.requestGenerateReport = function(successHandler)
{
    const self = this;

    function successMethod(data, textStatus, jqXHR)
    {
        if (successHandler)
            successHandler(data, textStatus, jqXHR);
        self.$exportButton.toggleClass('disabled', false);
    }

    function errorMethod(jqXHR, textStatus, errorThrown)
    {
        self.$exportButton.toggleClass('disabled', true);
        self.hideOverlay();

        if (textStatus === "rpc_noRights")
        {
            alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
            document.location.href = ReportConfigConstants.REPORTS_DASHBOARD_URL;
            return true;
        }

        if (textStatus === "rpc_sessionExpired")
            return false;

        if (textStatus === "rpc_customException")
        {
            if (errorThrown.exception === "com.actimind.actitime.reports.AllSelectedUsersWereDeletedException")
            {
                self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.no_selected_users"));
                return true;
            }
        }
        else
        {
            self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.network_error", [PRODUCT_NAME]));
            return true;
        }

        return false;
    }

    return makeRpcCall("TimeBalanceAndOvertimeReportService.getReport",
                       [this.makeServiceParams(this.reportParameters)],
                       successMethod,
                       errorMethod);
};

OvertimeReportMediator.prototype.renderGeneratedReport = function(data)
{
    const reportParams = _.clone(this.reportParameters);

    const info = {};
    const groupingLevels = BaseReport.ConvertUtils.getGroupingLevels(reportParams);
    for (let i = 0; i < data["groupingLevelsInfoLists"].length; ++i)
    {
        const groupingType = BaseReport.ConvertUtils.getGroupingType(i, groupingLevels);
        info[groupingType] = arrayToMap(data["groupingLevelsInfoLists"][i]);
    }

    OvertimeReportStore.setReportData(data["rootItem"], info);
    OvertimeReportStore.setReportParams(reportParams);

    if (this.overtimeReportTable)
        this.overtimeReportTable.cancelRendering();

    this.reportPlaceholder.empty();
    this.overtimeReportTable = new OvertimeReport.Table(this.reportPlaceholder, OvertimeReportStore).init();
    this.overtimeReportTable.update();

    $("#overtimeExtraNotes").toggle(reportParams.columnsConfig !== ColumnsConfig.TIME_BALANCE_ONLY);
};


// WEBPACK FOOTER //
// ./web/js/reports/OvertimeReportMediator.js